export default {
    devices_bulk_actions_title: "Acciones masivas",
    devices_bulk_actions_account: "Cuenta",
    devices_bulk_actions_manufacturer: "Fabricante",
    devices_bulk_actions_device_model: "Modelo de dispositivo",
    devices_bulk_actions_sim_provider: "Proveedor de Sims",
    devices_bulk_actions_device_name: "Nombre del dispositivo",
    devices_bulk_actions_imei: "IMEI",
    devices_bulk_actions_serial: "Serial",
    devices_bulk_actions_script: "Script",
    devices_bulk_actions_devices_will_be_affected: "Dispositivo(s) afectado(s)",
    devices_bulk_actions_promiles: "Promiles",
    devices_bulk_actions_analytics: "Analítica",
    devices_bulk_actions_show_ecu_speed: "Mostrar velocidad de la ECU",
    devices_bulk_actions_use_ecu_odometer: "Utilizar el cuentakilómetros de la ECU",
    devices_bulk_actions_device_category: "Categoría de dispositivos",
    devices_bulk_actions_send_command: "Enviar comando",
    devices_bulk_actions_fleet: "Flota",
    devices_bulk_actions_asset: "Asset",
    devices_bulk_actions_send_command_via: "Enviar comando a través de",
    devices_bulk_actions_sms: "SMS",
    devices_bulk_actions_ota: "OTA",
    devices_bulk_actions_open_command: "Comando abierto",
    devices_bulk_actions_command: "Comando",
    devices_bulk_actions_raw_command: "Comando en bruto",
    devices_bulk_send_command_via: "Enviar comando a través de",
    devices_bulk_yes: "Si",
    devices_bulk_no: "No",
    devices_bulk_sim_provider_account: "Cuenta de proveedor SIM",
    devices_bulk_active: "Activo",
    devices_bulk_inactive: "Inactivo",
    devices_bulk_enabled: "Activado",
    devices_bulk_disabled: "Desactivado",
    devices_bulk_driver_behavior: "Comportamiento del conductor",
    devices_bulk_it_is_necessary_to_select_an_account: "Es necesario seleccionar una cuenta",
    devices_bulk_the_features_have_been_edited: "Las características han sido editadas",
    devices_bulk_it_was_not_possible_to_update_the_features: "No fue posible actualizar las características",
    devices_bulk_apply_changes: "Aplicar cambios",
    devices_bulk_the_device_model_of_the_selected_devices: "El modelo de dispositivo de los dispositivos seleccionados debe ser el mismo",
    devices_bulk_the_unit_id_be_the_same: "La identificación de la unidad debe ser la misma",
    devices_bulk_you_have_no_devices_selected: "No tiene ningún dispositivo seleccionado",
    devices_bulk_you_must_select_a_sim_provider_account: "Debe seleccionar una cuenta de proveedor de Sim",
    devices_bulk_the_command_has_been_sent: "El comando ha sido enviado",
    devices_bulk_an_error_occurred_while_sending_the_command: "Se ha producido un error al enviar el comando",
    devices_bulk_you_must_apply_some_changes: "Debe aplicar algunos cambios en la configuración",
    devices_bulk_smartWitness_error: "No es posible realizar cambios en los dispositivos del fabricante de SmartWitness",
    devices_bulk_sim_timezone: "Zona Horaria",
    devices_bulk_features: "Cambiar Opciones en Masa",
    devices_bulk_actions_show:"Mostrar en la Web",
    devices_bulk_actions_linked_mode:"Modo",
    devices_bulk_actions_linked_mode_pair:"Vinculado",
    devices_bulk_actions_linked_mode_camera:"Como GPS",
    devices_bulk_actions_send_calc_odometer:"Enviar Odómetro Calculado",
    devices_bulk_actions_apu:"Apu",
    devices_bulk_actions_hybrid:"Hibrido",
    devices_bulk_actions_use_ecu_vin:"Usar Ecu Vin",
    devices_bulk_actions_tags:"Etiquetas",
    devices_bulk_actions_message: "La solicitud para actualizar los dispositivos ha sido enviada con éxito, por favor revise la lista de transacciones para ver el estado de la solicitud.",
    devices_bulk_select_command_for_each_group: "Seleccione un comando para cada grupo.",
    devices_bulk_unit_type: "Tipo de unidad",
    devices_bulk_command_entity_label: "{entity}: {name}",
    devices_bulk_devices_count: "Dispositivos afectados: {count}",
    devices_bulk_no_commands_available: "No hay comandos disponibles para los grupos seleccionados.",
}